<template>
  <div class="content-item">
    <h2 class="heading">Church Address</h2>
    <p class="text">This will be listed on the card</p>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <input v-model="card_address" type="text" name="textDemo" class="form-input" placeholder="Street Address" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <input v-model="card_address2" type="text" name="textDemo" class="form-input" placeholder="Street Address Line 2" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input v-model="card_city" type="text" name="textDemo" class="form-input" placeholder="City" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input v-model="card_state" type="text" name="textDemo" class="form-input" placeholder="State / Province" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input v-model="card_zipcode" type="text" name="textDemo" class="form-input" placeholder="Postal / Zip Code" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step10',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      card_address: '',
      card_address2: '',
      card_city: '',
      card_state: '',
      card_zipcode: '',
    };
  },
  methods: {
    submit() {
      this.$emit('input', {
        ...this.value,
        card_address: this.card_address,
        card_address2: this.card_address2,
        card_city: this.card_city,
        card_state: this.card_state,
        card_zipcode: this.card_zipcode,
      });
    },
  },
};
</script>
